import React from "react";
import { Box, Grid, Typography, Avatar } from "@mui/material";
import moment from "moment/min/moment-with-locales";
import { styled } from "@mui/material";

const ActivitatWrap = styled(Box)(({ theme }) => ({
	backgroundColor: "white",
	padding: 30,
	border: "6px solid white",
	borderRadius: 10,
	transition: ".2s",
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	position: "relative",
}));

const CustomAvatar = styled(Avatar)(({ theme }) => ({
	width: 120,
	height: 120,
	border: "8px solid white",
	cursor: "pointer",
	"& img": {
		objectPosition: "top",
		width: "90%",
	},
	marginBottom: 15,
}));

const Places = styled(Box)(({ theme }) => ({
	position: "absolute",
	top: 30,
	right: 20,
	paddingLeft: 15,
	paddingRight: 15,
	borderRadius: 20,
	backgroundColor: theme.palette.primary.main,
	"& p": {
		color: "white",
		fontSize: 16,
	},
	"& .ple": {
		color: theme.palette.error.main + "!important",
	},
}));

const Activitat = (props) => {
	const { activitat } = props;

	return (
		<ActivitatWrap
			style={{
				backgroundColor: activitat?.escola.color_alt,
			}}
		>
			<Grid container spacing={4}>
				<Grid item>
					<CustomAvatar
						alt={activitat.escola.nom}
						style={{
							backgroundColor: activitat.escola.color,
						}}
						src={
							"https://api.sinapsisberga.cat/storage/" +
							activitat.escola.imatge
						}
					/>
				</Grid>
				<Grid item>
					<Typography variant="caption" style={{ color: "white" }}>
						{activitat?.curs}
					</Typography>
					<Typography variant="h3" style={{ color: "white" }}>
						{activitat?.nom}
					</Typography>
					<Typography variant="body1" style={{ color: "white" }}>
						{activitat?.escola.nom}
					</Typography>
					<Box mt={3}>
						<Typography variant="body1" style={{ color: "white" }}>
							{activitat?.setmanal === "1" ? (
								<span
									style={{
										textTransform: "capitalize",
									}}
								>
									Diària
								</span>
							) : (
								<span
									style={{
										textTransform: "capitalize",
									}}
								>
									{moment(activitat?.dia, "e")
										.locale("ca")
										.format("dddd")}
								</span>
							)}{" "}
							de{" "}
							{moment(activitat?.hora_i, "HH:mm:ss").format(
								"H:mm"
							)}{" "}
							h a{" "}
							{moment(activitat?.hora_f, "HH:mm:ss").format(
								"H:mm"
							)}{" "}
							h
						</Typography>
						<Typography variant="body1" style={{ color: "white" }}>
							{activitat?.imparteix}
						</Typography>

						<Typography
							variant="caption"
							style={{ color: "white", opacity: 0.8 }}
						>
							{activitat?.preu} € / {activitat?.preu_soci} €
						</Typography>
					</Box>
				</Grid>
				<Places>
					<Typography
						variant="body1"
						className={
							activitat?.alumnes.length >= activitat?.places &&
							"ple"
						}
					>
						{activitat?.alumnes.length}/{activitat?.places}
					</Typography>
				</Places>
			</Grid>
		</ActivitatWrap>
	);
};

export default Activitat;
